export const _LOGIN_USER = 'ourakademy:applicant:auth'

export const retrieveLoggedInUser = () => JSON.parse(localStorage.getItem(_LOGIN_USER))

export const storeLoggedInUser = (user) => localStorage.setItem(_LOGIN_USER, JSON.stringify(user))

export const deleteUser = () => localStorage.removeItem(_LOGIN_USER)
